import React from 'react';
import { ThemeProvider } from 'styled-components';

type StyledProviderProps = {
  theme: string;
};

export const StyledProvider: React.FC<StyledProviderProps> = ({ theme, children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
